export const dateLabelMap: Record<string, string> = {
  EKG: "Data badania",
  "Holter RR": "Data rozpocz\u0119cia zapisu",
  "Holter EKG": "Data rozpocz\u0119cia zapisu",
  "Echo serca": "Data badania",
  Spirometria: "Data badania",
  "Badanie histopatologiczne": "Data badania",
  "Konsultacja specjalistyczna": "Data konsultacji",
  Mammografia: "Data badania",
  "Badanie obrazowe": "Data badania",
  Gastroskopia: "Data badania",
  Kolonoskopia: "Data badania",
  "Badania laboratoryjne": "Data badania",
  "Karta informacyjna SOR": "Data wydania karty",
  "Wypis ze szpitala": "Data wypisu",
  "Karta medycznych czynno\u015bci ratunkowych": "Data udzielenia pomocy",
};
